import { render, staticRenderFns } from "./mobileLayout.vue?vue&type=template&id=0b832a9b&"
import script from "./mobileLayout.vue?vue&type=script&lang=js&"
export * from "./mobileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports